const log = {
  error: console.error,
  warn: console.warn,
  info: console.log,
};

export default log;
